var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmartphone = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 27,
    viewBox: "0 0 17 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5662 0H3.43359C2.0355 0 0.902344 1.13316 0.902344 2.53125V24.4688C0.902344 25.8668 2.0355 27 3.43359 27H13.5662C14.9643 27 16.0974 25.8668 16.0974 24.4688V2.53125C16.0974 1.13316 14.9643 0 13.5662 0ZM14.4099 24.4688C14.4099 24.9345 14.0319 25.3125 13.5662 25.3125H3.43359C2.96784 25.3125 2.58984 24.9345 2.58984 24.4688V2.53125C2.58984 2.0655 2.96784 1.6875 3.43359 1.6875H13.5662C14.0319 1.6875 14.4099 2.0655 14.4099 2.53125V24.4688ZM8.50116 21.0984C7.57092 21.0984 6.81788 21.8523 6.81788 22.7812C6.81788 23.7102 7.57134 24.4646 8.50116 24.4646C9.43139 24.4646 10.1844 23.7102 10.1844 22.7813C10.1844 21.8523 9.43139 21.0984 8.50116 21.0984ZM10.1887 2.53125H6.81366C6.34791 2.53125 5.96991 2.90925 5.96991 3.375C5.96991 3.84075 6.34791 4.21875 6.81366 4.21875H10.1887C10.6544 4.21875 11.0324 3.84075 11.0324 3.375C11.0324 2.90925 10.6544 2.53125 10.1887 2.53125Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmartphone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/smartphone.547d647288a627ad60c68d7b39f9697e.svg";